var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BFFGateway } from "sb-bff-integration";
import { LeaguesParser } from "../../Parser";
import { getLeaguesRequest, getData, processItem } from "../../helpers";
import { BffRequestTypes } from "../../constants";
export class LeaguesRetriever {
    constructor() {
        this.parser = new LeaguesParser();
        this.processData = (items) => {
            return items.reduce((cacheLegacyArray, item) => {
                processItem(cacheLegacyArray, this.parser.parseData(item));
                return cacheLegacyArray;
            }, []);
        };
    }
    load(successCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.bff) {
                this.bff = new BFFGateway();
            }
            let leaguesResponse = yield getData(this.bff, BffRequestTypes.league, getLeaguesRequest());
            successCallback(this.processData(leaguesResponse));
        });
    }
}
//# sourceMappingURL=LeaguesRetriever.js.map